import React from 'react'
import style from '../card.module.css'

function Rencho() {
  return (
    <div  className={style.review_students}>
        <p>
            It's wonderful experience......😘😘 Specially thanks to the educators because they teach us with full dedication.
            ❤❤ And also thanks to them who made this wonderfully platform
            "UNACADEMY" because unacademy make my learning very easy in minimum...
        </p>    
      <div className={style.review_students_name_start}>
          <div>
            <h2>Rencho</h2>  
            <p>14,078 learning minutes • NDA</p>
          </div>
          <div>
            <h1>⭐⭐⭐⭐⭐</h1>  
            <p>2 month ago</p>  
          </div>
        </div>  
    </div>      
  )
}

export default Rencho